import React from 'react';
import { Header } from '../abstractComponent/Header';
import { translator } from '../helpers/translator';

export default function Bandeau({ items, lang, search, setSearch }) {
return ( <div className="bandeau container"></div>)
}